var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { ContentBaseService } from '../../../../../component/base/contentbase.service';
var KtsRadioVerticalComponent = /** @class */ (function (_super) {
    __extends(KtsRadioVerticalComponent, _super);
    function KtsRadioVerticalComponent(service, baseService, contentService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.contentService = contentService;
        _this.dataOptions = [];
        return _this;
    }
    KtsRadioVerticalComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
        this.setValue();
    };
    KtsRadioVerticalComponent.prototype.ngOnChanges = function (changes) {
        this.setValue();
        _super.prototype.ngOnChanges.call(this, changes);
    };
    KtsRadioVerticalComponent.prototype.getType = function () {
        var _this = this;
        this.contentService.getType(this.col.dataType).subscribe(function (rec) { return _this.dataOptions = rec; });
    };
    KtsRadioVerticalComponent.prototype.setValue = function () {
        if (typeof this.val === 'undefined' || this.val === null || this.val === '') {
            if (this.dataOptions && this.dataOptions.length > 0 && this.col.required) {
                this.val = this.dataOptions[0].code;
            }
            else {
                this.val = '';
            }
            _super.prototype.onChange.call(this, this.val, false);
        }
        this.val = this.val.toString();
    };
    KtsRadioVerticalComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-radio-vertical',
                    template: "<ng-template [ngIf]=\"col.readonly\" [ngIfElse]=\"elseBlock\">\n  <column-formreadonly [col]=\"{\n    controlType: 'select',\n    params: {options: dataOptions}\n  }\" [val]=\"val\" [msg]=\"msg\">\n</column-formreadonly>\n</ng-template>\n<ng-template #elseBlock>\n  <ng-template [ngIf]=\"!col.required\">\n    <li class=\"form_li\">\n      <input type=\"radio\" class=\"formInputRadio\" id=\"{{ colKey }}-\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" value=\"\" [(ngModel)]=\"val\" (change)=\"onChange(val)\" [key]=\"key\" [col]=\"col\" columnDir>\n      <label for=\"{{ colKey }}-\" class=\"formInputRadioLabel\" [key]=\"key\" [col]=\"col\" columnDir>{{ msg['RadioComponent.label.notSet'] }}</label>\n    </li>\n  </ng-template>\n  <ng-template ngFor let-option [ngForOf]=\"dataOptions\">\n    <li class=\"form_li form_li-break\">\n      <input type=\"radio\" class=\"formInputRadio\" id=\"{{ colKey }}-{{ option.code }}\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [value]=\"option.code.toString()\" [(ngModel)]=\"val\" (change)=\"onChange(val)\" [key]=\"key\" [col]=\"col\" columnDir>\n      <label for=\"{{ colKey }}-{{ option.code }}\"  class=\"formInputRadioLabel\" [key]=\"key\" [col]=\"col\" columnDir>{{ option.display }}</label>\n    </li>\n   </ng-template>\n</ng-template>\n"
                }] }
    ];
    /** @nocollapse */
    KtsRadioVerticalComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ContentBaseService }
    ]; };
    return KtsRadioVerticalComponent;
}(ColumnBaseComponent));
export { KtsRadioVerticalComponent };
//# sourceMappingURL=radio-vertical.component.js.map